export const REACT_RENDER = 'REACT_RENDER';
export const COMPONENT_CATCH_ERROR = 'COMPONENT_CATCH_ERROR';
export const GRAPHQL_ERROR = 'GRAPHQL_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const USER_CHANGE = 'USER_CHANGE';
export const ORG_CHANGE = 'ORG_CHANGE';
